import React from 'react'

import ReactJson from '@microlink/react-json-view'
import { Card, CardContent, CardHeader, Grid } from '@mui/material'
import omit from 'lodash/omit'

const AuditEmailDetailsView = (row: any) => {
  const data = {
    timestamp: row.timestamp,
    meta: row.meta,
    payload: omit(row.payload, ['html', 'text']),
  }

  return (
    <Grid container spacing={1} style={{ width: '100%', margin: 0 }}>
      <Grid
        size={{
          sm: 6,
        }}>
        <Card>
          <CardContent>
            <iframe frameBorder="0" height="400px" srcDoc={row.payload.html} width="100%" />
          </CardContent>
        </Card>
      </Grid>
      <Grid
        size={{
          sm: 6,
        }}>
        <CardHeader title="Workflow configuration" />
        <CardContent>
          <ReactJson displayDataTypes={false} src={data} />
        </CardContent>
      </Grid>
    </Grid>
  )
}

export default AuditEmailDetailsView
